import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Container from 'components/Container';
import TopNav from 'components/TopNav';
import { Topbar, Sidebar, Footer } from './components';
import pages from '../navigation';

const Main = ({ children, colorInvert = false, bgcolor = 'transparent' }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });
  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => setOpenSidebar(true);
  const handleSidebarClose = () => setOpenSidebar(false);
  const open = isMd ? false : openSidebar;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  return (
    <Box sx={{ minHeight: '100vh', width: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* TopNav (scrolls normally) */}
      <Box bgcolor={bgcolor} position={'relative'} zIndex={theme.zIndex.appBar}>
          <TopNav colorInvert={colorInvert} />
      </Box>

      {/* Sticky AppBar */}
      <AppBar
        position="sticky"
        sx={{
          top: 0,
          zIndex: theme.zIndex.appBar + 10,
          backgroundColor: trigger ? theme.palette.background.paper : bgcolor,
          transition: 'background-color 0.3s ease',
        }}
        elevation={trigger ? 1 : 0}
      >
        <Toolbar disableGutters>
            <Topbar
              onSidebarOpen={handleSidebarOpen}
              pages={pages}
              colorInvert={trigger ? false : colorInvert}
            />
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Sidebar
        onClose={handleSidebarClose}
        open={open}
        variant="temporary"
        pages={pages}
      />

      {/* Main content */}
      <main style={{ flex: 1, width: '100%' }}>
        {children}
        <Divider />
      </main>

      {/* Footer */}
      <Container paddingY={4}>
        <Footer />
      </Container>
    </Box>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  colorInvert: PropTypes.bool,
  bgcolor: PropTypes.string,
};

export default Main;
